module.exports = __webpack_public_path__ + "img/no-profile-pic.732aed8f.svg";